"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonerisCoreModifiers = exports.MonerisCoreTransactionTypes = exports.ErrorResponseCode = exports.StatusResponseCode = exports.DeclinedResponseCollection = exports.DeclinedResponseCode = exports.ApprovedResponseCollection = exports.ApprovedResponseCode = exports.InitialResponseCode = void 0;
// Initial Response Codes
var InitialResponseCode;
(function (InitialResponseCode) {
    InitialResponseCode["ACCEPTED"] = "201";
    InitialResponseCode["ACCEPTED_FOR_DUPLICATE_REQUEST"] = "202";
})(InitialResponseCode || (exports.InitialResponseCode = InitialResponseCode = {}));
// Final Response Codes
var ApprovedResponseCode;
(function (ApprovedResponseCode) {
    ApprovedResponseCode["APPROVED"] = "207";
    ApprovedResponseCode["COMPLETED"] = "209";
    ApprovedResponseCode["PARTIALLY_APPROVED"] = "210";
    ApprovedResponseCode["APPROVED_WITHOUT_CASH_BACK"] = "211";
    ApprovedResponseCode["TRANSACTION_SUCCESSFULLY_CANCELLED"] = "220";
})(ApprovedResponseCode || (exports.ApprovedResponseCode = ApprovedResponseCode = {}));
exports.ApprovedResponseCollection = [
    ApprovedResponseCode.APPROVED,
    ApprovedResponseCode.COMPLETED,
    ApprovedResponseCode.PARTIALLY_APPROVED,
    ApprovedResponseCode.APPROVED_WITHOUT_CASH_BACK,
    ApprovedResponseCode.TRANSACTION_SUCCESSFULLY_CANCELLED,
];
var DeclinedResponseCode;
(function (DeclinedResponseCode) {
    DeclinedResponseCode["DECLINED"] = "450";
    DeclinedResponseCode["TRANSACTION_CANCELED"] = "451";
    DeclinedResponseCode["CUSTOMER_PROMPT_TIMEOUT"] = "452";
    DeclinedResponseCode["NOT_COMPLETED"] = "453";
    DeclinedResponseCode["NOT_ALLOWED"] = "454";
    DeclinedResponseCode["CANCELLED_BY_ECR"] = "455";
    DeclinedResponseCode["RETRY_IN_PROGRESS"] = "456";
    DeclinedResponseCode["PARTIAL_AUTHORIZATION_CANCELLED"] = "457";
    DeclinedResponseCode["REQUEST_ERROR"] = "460";
    DeclinedResponseCode["TERMINAL_BUSY"] = "461";
    DeclinedResponseCode["REQUEST_NOT_ALLOWED"] = "462";
    DeclinedResponseCode["INVALID_PASSWORD"] = "463";
})(DeclinedResponseCode || (exports.DeclinedResponseCode = DeclinedResponseCode = {}));
// DeclinedResponseCode.REQUEST_ERROR is the error code
exports.DeclinedResponseCollection = [
    DeclinedResponseCode.DECLINED,
    DeclinedResponseCode.TRANSACTION_CANCELED,
    DeclinedResponseCode.CUSTOMER_PROMPT_TIMEOUT,
    DeclinedResponseCode.NOT_COMPLETED,
    DeclinedResponseCode.NOT_ALLOWED,
    DeclinedResponseCode.CANCELLED_BY_ECR,
    DeclinedResponseCode.RETRY_IN_PROGRESS,
    DeclinedResponseCode.PARTIAL_AUTHORIZATION_CANCELLED,
    DeclinedResponseCode.REQUEST_ERROR,
    DeclinedResponseCode.TERMINAL_BUSY,
    DeclinedResponseCode.REQUEST_NOT_ALLOWED,
    DeclinedResponseCode.INVALID_PASSWORD,
];
// Status Response Codes
var StatusResponseCode;
(function (StatusResponseCode) {
    StatusResponseCode["TIP_PROMPT_SCREEN"] = "101";
    StatusResponseCode["TIP_BY_AMOUNT_SCREEN"] = "102";
    StatusResponseCode["TIP_BY_PERCENTAGE_SCREEN"] = "103";
    StatusResponseCode["LANGUAGE_PROMPT_SCREEN"] = "104";
    StatusResponseCode["APPLICATION_SELECTION_PROMPT_SCREEN"] = "105";
    StatusResponseCode["APPLICATION_SELECTION_CONFIRMATION_SCREEN"] = "106";
    StatusResponseCode["CASHBACK_PROMPT_SCREEN"] = "107";
    StatusResponseCode["CASHBACK_AMOUNT_SCREEN_CUSTOM_CASHBACK_SELECTED"] = "108";
    StatusResponseCode["DCC_PROMPT_SCREEN"] = "109";
    StatusResponseCode["SURCHARGE_CONFIRMATION_SCREEN"] = "110";
    StatusResponseCode["CARD_ENTRY"] = "111";
    StatusResponseCode["AMOUNT_CONFIRMATION"] = "112";
    StatusResponseCode["ACCOUNT_SELECTION_CHQ_SAV"] = "113";
    StatusResponseCode["PIN_ENTRY_PROMPT_SCREEN"] = "114";
    StatusResponseCode["REMOVE_CARD_SCREEN"] = "115";
    StatusResponseCode["RECEIPT_PROMPT_SCREEN"] = "116";
    StatusResponseCode["RECEIPT_BY_EMAIL_SCREEN"] = "117";
    StatusResponseCode["RECEIPT_BY_TEXT_SCREEN"] = "118";
    StatusResponseCode["BALANCE_INQUIRY_SCREEN"] = "119";
    StatusResponseCode["SENDING_TRANSACTION_TO_MONERIS"] = "120";
    StatusResponseCode["PRINTING_CUSTOMER_RECEIPT"] = "121";
    StatusResponseCode["PRINTING_MERCHANT_RECEIPT"] = "122";
    StatusResponseCode["RECEIPT_PRINTING_ERROR"] = "123";
    StatusResponseCode["APPROVAL_SCREEN"] = "124";
    StatusResponseCode["RELEASING_SAF"] = "125";
    StatusResponseCode["PASSWORD_PROMPT_SCREEN"] = "126";
    StatusResponseCode["CARD_MANUAL_ENTRY"] = "127";
    StatusResponseCode["CVD_BYPASS_REASON_PROMPT_SCREEN"] = "128";
    StatusResponseCode["CUSTOMER_ERROR_CARD_NOT_SUPPORTED"] = "129";
    StatusResponseCode["OBTAINING_CURRENCY_INFO_FROM_MONERIS"] = "130";
    StatusResponseCode["PARTIAL_APPROVAL_CONFIRMATION_SCREEN"] = "131";
    StatusResponseCode["PARTIAL_APPROVAL_REJECTED_SCREEN"] = "132";
    StatusResponseCode["CARD_REMOVED"] = "133";
    StatusResponseCode["RECEIPT_PRINTING_BYPASSED_BY_CUSTOMER"] = "134";
    StatusResponseCode["PRINTED_RECEIPT_REQUESTED_BY_CUSTOMER"] = "135";
    StatusResponseCode["EMAIL_RECEIPT_SENT_TO_CUSTOMER"] = "136";
    StatusResponseCode["SMS_RECEIPT_SENT_TO_CUSTOMER"] = "137";
    StatusResponseCode["GIFT_CARD_CVC_ENTRY_SCREEN"] = "141";
    StatusResponseCode["CUSTOMER_INFO_ENTRY_SCREEN"] = "142";
    StatusResponseCode["LOAD_AMOUNT_SCREEN"] = "143";
    StatusResponseCode["BENEFIT_AMOUNT_ENTRY_SCREEN"] = "144";
})(StatusResponseCode || (exports.StatusResponseCode = StatusResponseCode = {}));
/**
 * Error Response Codes
 * This code is found status `DeclinedResponseCode.REQUEST_ERROR = "460"` and  `data: { errorDetails: {...} }`
 */
var ErrorResponseCode;
(function (ErrorResponseCode) {
    ErrorResponseCode["INVALID_PARAMETER"] = "901";
    ErrorResponseCode["INVALID_LENGTH"] = "902";
    ErrorResponseCode["INVALID_FORMAT"] = "903";
    ErrorResponseCode["MISSING_PARAMETER"] = "904";
    ErrorResponseCode["DUPLICATE_VALUE"] = "905";
    ErrorResponseCode["INTERNAL_ERROR"] = "909";
})(ErrorResponseCode || (exports.ErrorResponseCode = ErrorResponseCode = {}));
var MonerisCoreTransactionTypes;
(function (MonerisCoreTransactionTypes) {
    /**
     * Purchase
     */
    MonerisCoreTransactionTypes["PURCHASE"] = "PURCHASE";
    /**
     * Refund
     */
    MonerisCoreTransactionTypes["REFUND"] = "REFUND";
    /**
     * Void
     */
    MonerisCoreTransactionTypes["CORRECTION"] = "CORRECTION";
    /**
     * Balance inquiry
     */
    MonerisCoreTransactionTypes["INQUIRY"] = "INQUIRY";
    /**
     * Pre-authorization
     */
    MonerisCoreTransactionTypes["PREAUTHORIZATION"] = "PREAUTHORIZATION";
    /**
     * Pre-authorization completion
     */
    MonerisCoreTransactionTypes["COMPLETION"] = "COMPLETION";
    /**
     * Activation / Load
     */
    MonerisCoreTransactionTypes["ACTIVATION"] = "ACTIVATION";
    /**
     * Deactivation
     */
    MonerisCoreTransactionTypes["DEACTIVATION"] = "DEACTIVATION";
    /**
     * Cancel
     */
    MonerisCoreTransactionTypes["CANCEL"] = "CANCEL";
})(MonerisCoreTransactionTypes || (exports.MonerisCoreTransactionTypes = MonerisCoreTransactionTypes = {}));
/**
 * Not all modifiers can be used with all transaction types.
 */
var MonerisCoreModifiers;
(function (MonerisCoreModifiers) {
    /**
     * The Assisted UnionPay modifier is used to trigger an Assissted UnionPay transaction on the terminal. This is required only if a UnionPay transaction fails.
     *
     * @description
     * Available transaction types: PURCHASE, REFUND, PREAUTHORIZATION
     */
    MonerisCoreModifiers["UNIONPAY"] = "UNIONPAY";
    /**
     * The Cash modifier is used to trigger a cash payment transaction.
     *
     * @description
     * Available transaction types: PURCHASE, REFUND
     */
    MonerisCoreModifiers["CASH"] = "CASH";
    /**
     * The Gift modifier is used to trigger a non-moneris gift transaction.
     *
     * @description
     * Available transaction types: PURCHASE, REFUND, CORRECTION, INQUIRY
     */
    MonerisCoreModifiers["GIFT"] = "GIFT";
    /**
     * The Loyalty modifier is used to trigger a Loyalty only transaction.
     *
     * @description
     * Available transaction types: PURCHASE, REFUND, PREAUTHORIZATION, CORRECTION
     */
    MonerisCoreModifiers["LOYALTY"] = "LOYALTY";
    /**
     * The CNP modifier is used for Card Not Present / MOTO transactions. This value allows the user to manually enter card details into the terminal.
     *
     * @description
     * Available transaction types: PURCHASE, REFUND, PREAUTHORIZATION
     */
    MonerisCoreModifiers["CNP"] = "CNP";
})(MonerisCoreModifiers || (exports.MonerisCoreModifiers = MonerisCoreModifiers = {}));
//# sourceMappingURL=monerisCoreVocabulary.js.map